export const InvitationStatus = {
  Rejected: -1,
  Accepted: 1,
  Manual: 0,
  Pending: 2,
  Expired: 3,
  NotFound: 404
}
